import styled from 'styled-components';
import { StyledAppRadio } from '../AppRadio/index.styled';

export const StyledAppRadioReversed = styled(StyledAppRadio)`
  flex-direction: row-reverse;
  width: 100%;

  .ant-radio-label {
    flex: 1;
  }
`;
